import React from 'react';
import { Form } from 'react-bootstrap';
import styles from './customSearch.module.scss';

export const CustomSearch = (props) => {
    return (
        <div>
            <Form>
                <Form.Group className={styles.formText}>
                    <Form.Control
                        type={props.type}
                        placeholder={props.placeholder}
                        onChange={props.handleOnChange}
                        className={styles.CustomSearchBar}
                        id={props.id}
                    />
                    <div className={styles.searchIcon}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="#828282" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M21 21L16.65 16.65" stroke="#828282" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                </Form.Group>
            </Form>
        </div>
    )
}
